module.exports = __webpack_public_path__ + "img/ad2.7e59a9f7.jpg";